class CartDetails extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
  }

  bindEvents() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.initializeButtons());
    } else {
      this.initializeButtons();
    }

    document.addEventListener('cart:updated', () => {
      this.initializeButtons();
    });
  }

  initializeButtons() {
    const toggleButtons = document.querySelectorAll('.cart-item__details-toggle');
    toggleButtons.forEach(button => {
      button.removeEventListener('click', this.handleToggleClick);
      button.addEventListener('click', this.handleToggleClick.bind(this));
    });

    const editButtons = document.querySelectorAll('.cart-item__edit-button');
    editButtons.forEach(button => {
      button.removeEventListener('click', this.handleEditClick);
      button.addEventListener('click', this.handleEditClick.bind(this));
    });
  }

  handleToggleClick(event) {
    const button = event.currentTarget;
    this.toggleDetails(button);
  }

  handleEditClick(event) {
    const button = event.currentTarget;
    this.editDetails(button);
  }

  toggleDetails(button) {
    const wrapper = button.closest('.cart-item__details-wrapper');
    if (!wrapper) return;

    const content = wrapper.querySelector('.cart-item__details-content');
    if (!content) return;

    const isHidden = content.hidden;
    content.hidden = !isHidden;
    button.setAttribute('aria-expanded', !isHidden);
    button.textContent = isHidden ? 'Show Less' : 'View Full Details';

    if (!isHidden) {
      content.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  editDetails(button) {
    try {
      console.log('Edit button clicked');
      const itemKey = button.getAttribute('data-item-key');

      // 1. Find the .cart-item__details-wrapper.
      const detailsWrapper = button.closest('.cart-item__details-wrapper');
      if (!detailsWrapper) {
        console.log('No details wrapper found');
        return;
      }

      // 2. Locate either .cart-item or .cart-item-personalization.
      let cartItemRow = button.closest('.cart-item');
      if (!cartItemRow) {
        cartItemRow = button.closest('.cart-item-personalization');
      }
      if (!cartItemRow) {
        console.log('No cart item or personalization row found');
        return;
      }

      // 3. Attempt to read data-product-tags from whichever row we found.
      let productTagsString = cartItemRow.getAttribute('data-product-tags') || '';
      let variantTitle = cartItemRow.getAttribute('data-variant-title') || '';

      // 4. If we are on the .cart-item-personalization row and there's no data-product-tags,
      //    fallback to the previous row (which should be .cart-item).
      if (!productTagsString && cartItemRow.classList.contains('cart-item-personalization')) {
        const prevRow = cartItemRow.previousElementSibling;
        if (prevRow && prevRow.classList.contains('cart-item')) {
          productTagsString = prevRow.getAttribute('data-product-tags') || '';
          if (!variantTitle) {
            variantTitle = prevRow.getAttribute('data-variant-title') || '';
          }
        }
      }

      const productTags = productTagsString ? JSON.parse(productTagsString) : [];
      console.log('Product tags:', productTags);
      console.log('Variant title:', variantTitle);

      // 5. Now wait for the form modal, then parse the properties and call editItem.
      const waitForModal = () => {
        const formModal = document.querySelector('cart-form-modal');
        if (formModal) {
          try {
            const detailsContent = detailsWrapper.querySelector('.cart-item__details-content');
            const previewContent = detailsWrapper.querySelector('.cart-item__details-preview');
            const containerForProperties = detailsContent || previewContent;
            if (!containerForProperties) {
              throw new Error('No container for properties found');
            }

            // If there's a full-details container and it is hidden, unhide it
            if (detailsContent && detailsContent.hidden) {
              detailsContent.hidden = false;
            }

            // Collect properties from the container
            const properties = {};
            containerForProperties.querySelectorAll('.product-option').forEach(option => {
              const dt = option.querySelector('dt');
              const dd = option.querySelector('dd');
              if (dt && dd) {
                let label = dt.textContent.replace(':', '').trim();
                const value = dd.textContent.trim();
                label = label
                  .replace('properties', '')
                  .replace('[', '')
                  .replace(']', '')
                  .trim();
                properties[label] = value;
              }
            });
            console.log('Properties collected:', properties);

            // Hand off to the modal
            formModal.updateFormType(productTags, variantTitle);
            formModal.currentItemKey = itemKey;
            formModal.editItem(properties);

            // Re-hide the full details if we unhid it
            if (detailsContent && detailsContent.hidden === false) {
              detailsContent.hidden = true;
            }

          } catch (modalError) {
            console.error('Error in modal operations:', modalError);
            throw modalError;
          }
        } else {
          // Try again in 100ms if modal not found
          setTimeout(waitForModal, 100);
        }
      };

      waitForModal();

    } catch (error) {
      console.error('Full error details:', error);
      const errorMsg = document.createElement('div');
      errorMsg.className = 'cart-error-message';
      errorMsg.textContent = `Error: ${error.message || 'Unable to edit details. Please try again.'}`;
      button.parentNode.insertBefore(errorMsg, button.nextSibling);
      setTimeout(() => errorMsg.remove(), 3000);
    }
  }

  disconnectedCallback() {
    const toggleButtons = document.querySelectorAll('.cart-item__details-toggle');
    const editButtons = document.querySelectorAll('.cart-item__edit-button');

    toggleButtons.forEach(button => {
      button.removeEventListener('click', this.handleToggleClick);
    });
    editButtons.forEach(button => {
      button.removeEventListener('click', this.handleEditClick);
    });
  }
}

customElements.define('cart-details', CartDetails);
